module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/estado/estado.component.css
// module id = ./src/app/estado/estado.component.css
// module chunks = main